import { useQuery } from "@tanstack/react-query";
import { api, keys, type Named, type Uuid } from "@shared/api";
import { useMe } from "@entities/session";
import { fromSelf, livePerson, Tile } from "@entities/user";
import { plural } from "@shared/lib/format";

/**
 * Кто в ветке — колонка справа у ветки на весь экран, как в Discord. В ветке
 * те, кто за ней следит: написал в ней, присоединился или открыл её из меню.
 */
export function ThreadMembers({
  channelId,
  threadId,
  people,
  onOpenProfile,
}: {
  channelId: Uuid;
  threadId: Uuid;
  people: Map<Uuid, Named>;
  onOpenProfile: (userId: Uuid, anchor?: HTMLElement) => void;
}) {
  const me = fromSelf(useMe());
  const { data: members } = useQuery({
    queryKey: keys.threadMembers(threadId),
    queryFn: () => api.threads.members(channelId, threadId).then((answer) => answer.items),
    staleTime: 15_000,
  });

  return (
    <aside className="panel panel-wide glass-host thread-members">
      <header className="panel-head">
        {members
          ? `В ветке — ${members.length} ${plural(members.length, "участник", "участника", "участников")}`
          : "В ветке"}
      </header>
      <div className="thread-members-list">
        {members?.map((member) => {
          const person = livePerson(member, people, me);
          return (
            <button key={member.id} type="button" className="thread-member" onClick={(event) => onOpenProfile(member.id, event.currentTarget)}>
              <Tile person={person} size={32} />
              <span className="ellipsis">{person.name}</span>
            </button>
          );
        })}
      </div>
    </aside>
  );
}
